var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207764 1.4075L5.17346 7.20235C5.2535 7.29571 5.35279 7.37065 5.46451 7.42202C5.57624 7.4734 5.69775 7.5 5.82072 7.5C5.9437 7.5 6.06521 7.4734 6.17694 7.42202C6.28866 7.37065 6.38795 7.29571 6.46799 7.20235L11.4337 1.4075C11.9076 0.854378 11.5147 0 10.7864 0H0.853609C0.125345 0 -0.267562 0.854378 0.207764 1.4075Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretArrow);
export default __webpack_public_path__ + "static/media/caret-arrow.b52723c51bc92439f12b966c5343ae9c.svg";
export { ForwardRef as ReactComponent };